<div class="logo-content">
  @if (menuconfig && !(menuconfig.isModelProvider || menuconfig.isMMCAdmin)) {
    <div>
      <a [routerLink]="['/home']">
        <img src="/assets/Schwab-iRebal-logo-ko.svg"
          class="logo-img-padding"
          height="36px"
          alt="Charles Schwab iRebal"/>
      </a>
    </div>
  }
  @if (menuconfig && (menuconfig.isModelProvider || menuconfig.isMMCAdmin)) {
    <div>
      <a [routerLink]="['/models/model-market-center']">
        <img src="/assets/Schwab-iRebal-logo-ko.svg"
          class="logo-img-padding"
          height="36px"
          alt="Charles Schwab iRebal"/>
      </a>
    </div>
  }
</div>
@if (menuconfig
  && !menuconfig.isModelProvider ) {
  <div class="irb-nav-menu"
    >
    <ul>
      @for (category of menuData; track category; let last = $last; let i = $index) {
        <li
          [class]="[category.items ? 'dropdown' : '']"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{exact: true}">
          @if (category.disabled) {
            <a
              href="javascript:void(0)"
              id="{{category.id}}"
              [class]="[category.disabled ? 'menu-disabled' : '']"
              routerLinkActive="active-link"
              >
              {{category.label}}
            </a>
          }
          @if (!category.disabled && !category.items) {
            <a
              href="javascript:void(0)"
              id="{{category.id}}"
              [class]="[category.disabled ? 'menu-disabled' : '']"
              routerLink="{{category.routerLink}}"
              routerLinkActive="active-link"
              >
              {{category.label}}
            </a>
          }
          @if (!category.disabled && category.items) {
            <a href="javascript:void(0)"
              id="{{category.id}}"
              class="dropbtn"
              >
              {{category.label}}
              <i class="material-icons md-24 md-align dropdown-arrow-align">arrow_drop_down</i>
            </a>
          }
          @if (category.items) {
            <div class="dropdown-content">
              @for (item of category.items; track item) {
                <span>
                  @if (item.disabled) {
                    <a id="{{item.id}}"
                      [class]="[item.disabled ? 'menu-disabled' : '']"
                      routerLinkActive="active-link-submenu"
                      [routerLinkActiveOptions]="{exact: true}">
                      {{ item.label }}
                    </a>
                  }
                  @if (!item.disabled && (item.routerLink)) {
                    <a id="{{item.id}}"
                      routerLink="{{item.routerLink}}"
                      [class]="[item.disabled ? 'menu-disabled' : '']"
                      routerLinkActive="active-link-submenu"
                      [routerLinkActiveOptions]="{exact: true}">
                      {{ item.label }}
                    </a>
                  }
                  @if (!item.disabled && item.click) {
                    <a id="{{item.id}}"
                      [class]="[item.disabled ? 'menu-disabled' : '']"
                      routerLinkActive="active-link-submenu"
                      [routerLinkActiveOptions]="{exact: true}"
                      (click)="item.click()"
                      href="javascript:void(0)">
                      {{ item.label }}
                    </a>
                  }
                </span>
              }
            </div>
          }
        </li>
      }
      @if (menuconfig && !(menuconfig.isModelProvider || menuconfig.isMMCAdmin)) {
        <li><div class="nav__item_help"></div></li>
      }
    </ul>
  </div>
}

@if (menuconfig && menuconfig.isModelProvider) {
  <div class="irb-provider-title">
    <div class="provider-title-msg pageTitle">Model Market Center</div>
  </div>
}
@if (menuconfig && menuconfig.isModelProvider) {
  <div class="irb-provider-title">
    <div style="padding-top: 20px;">For additional information, contact your Relationship Manager</div>
  </div>
}

@if ( menuconfig && menuconfig; as userDetails) {
  <div class="nav" id="navLinks">
    <irb-exports-panel></irb-exports-panel>
    @if (!menuconfig.isModelProvider) {
      <a id="settingsLink" class="nav__link" (click)="showGlobalSettingsDialog();"
        ><i
      class="material-icons md-24 md-align lock-img-align nav__link_icon" title="Settings">settings</i>
    </a>
  }
  <a class="nav__link" (click)="logOut();">
    <i class="material-icons md-24 md-align lock-img-align nav__link_icon"
    title="Close iRebal and stay logged into SAC">lock</i>
  </a>
</div>
}